import api from './http';

function normalizePaymentMethodId(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  const number = Number(text);
  return Number.isFinite(number) && String(Math.trunc(number)) === text ? number : text;
}

export const FormaPagamentoAPI = {
  listarFormasPagamento: (params = {}) => api.get('/formapagamento/buscar', { params })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.response?.status !== 404) throw error;
      return api.get('/service-cost-centers/bling/payment-methods', { params }).then((response) => response.data);
    }),
  obterFormaPagamentoPorId: (id) => api.get(`/formapagamento/${id}`).then((response) => response.data),
  sincronizarFormasPagamento: (params = {}) => api.get('/formapagamento/sync', { params }).then((response) => response.data),
  sincronizarFormaPagamentoPorId: (id) => api.get(`/formapagamento/sync/${id}`).then((response) => response.data),
  montarParcelaComFormaPagamento: ({ valor, dataVencimento, formaPagamentoId, numeroDias = 0 } = {}) => {
    const id = normalizePaymentMethodId(formaPagamentoId);
    if (!id) return null;
    return {
      numeroDias,
      ...(dataVencimento ? { dataVencimento } : {}),
      valor: Number(valor || 0),
      formaPagamento: { id }
    };
  }
};
